import React from "react";
import Button from "../Button";
import CardDots from "./CardDots";
import T from "i18n-react";
import Style from "./ConfirmPayment.module.scss";
export interface IConfirmationButtons {
  paymentDetails: any;
  isLoading: boolean;
  changeCard: () => void;
  processPayment: () => void;
}

const ConfirmationButtons = (props: IConfirmationButtons) => {
  function cardDisplayType() {
    const cardType = props.paymentDetails.card_type;
    if (cardType === "visa") {
      return <img src={require("../../../imges/Visa.svg")} alt="" />;
    } else if (cardType === "mastercard") {
      return (
        <img src={require("../../../imges/master card logo.svg")} alt="" />
      );
    } else {
      return T.translate("Payment.YourSavedCard");
    }
  }
  return (
    <div className={Style.ConfirmPayments}>
      <div className={Style.CardDetails}>
        <span
          className={"consumer-credit"}
          style={{
            fontSize: "1.5rem",
            marginRight: "5px",
          }}
        />
        <CardDots />
        <CardDots />
        <CardDots />
        <p>
          {props.paymentDetails.masked_card_number.substr(
            props.paymentDetails.masked_card_number.length - 4
          )}
        </p>
      </div>
      <div>
        <Button
          title={"ChangeCardDetails"}
          className={Style.changeCardButton}
          onClick={props.changeCard}
          dataComponentName={"ChangeCardDetails"}
        />
      </div>
      <div className={Style.SubmitCardDetails}>
        <Button
          isLoading={props.isLoading}
          className={Style.SubmitCardDetailsButton}
          dataComponentName="PayWithButton"
          embeddedComponent={
            <p>
              {T.translate("Payment.PayWith")} {cardDisplayType()}
            </p>
          }
          onClick={props.isLoading ? () => {} : props.processPayment}
        />
      </div>
    </div>
  );
};

export default ConfirmationButtons;
